import { z } from 'zod';

export const copilotConfigOverrideSchema = z.object({
  group: z.string(),
  key: z.string(),
  value: z.string(),
});

export type CopilotConfigOverride = z.infer<typeof copilotConfigOverrideSchema>;
